/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { EventEmitter, Injectable, Output } from '@angular/core';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { ProfileService } from '@app/profile/profile.service';
import { Logger } from '@app/core';

const log = new Logger('ActivitiesService');

@Injectable({
  providedIn: 'root',
})
export class ActivitiesService {
  @Output() open: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() isOpened: boolean;
  @Output() passOptions: EventEmitter<any> = new EventEmitter();
  collectionName = 'activitiesSidebar';

  constructor(private profileService: ProfileService) {}

  /**
   * Default force open
   * @param subjectType LaravelModelsEnum
   * @param subjectId number
   * @param overlay bool
   */
  show(subjectType: LaravelModelsEnum, subjectId: number, overlay: boolean = true): void {
    this.profileService.setSetting(subjectType, true, this.collectionName).subscribe(() => {
      this.checkRequiredFields(subjectType);
      this.checkRequiredFields(subjectId);
      this.open.emit({ subjectType: subjectType, subjectId: subjectId, overlay: overlay });
    });
  }

  /**
   * Hide activities sidebar
   * @param subjectType LaravelModelsEnum
   */
  hide(subjectType?: LaravelModelsEnum): void {
    if (subjectType) {
      this.profileService.setSetting(subjectType, false, this.collectionName).subscribe(() => {
        this.close.emit();
      });
    } else {
      this.close.emit();
    }
  }

  /**
   * Check whether the sidebar is true or false in the settings
   * @param subjectType LaravelModelsEnum
   * @param subjectId number
   * @param overlay boolean
   * @param defaultValue boolean
   */
  auto(subjectType: LaravelModelsEnum, subjectId: number, overlay: boolean, defaultValue: boolean = true): void {
    if (this.profileService.getSetting(subjectType, this.collectionName, defaultValue)) {
      return this.show(subjectType, subjectId, overlay);
    }

    this.hide(subjectType);
  }

  optionsPass(options: any) {
    this.passOptions.emit(options);
  }

  private checkRequiredFields(input: any): void {
    if (input === null || input === undefined) {
      throw new Error('ActivitiesService Missing required attribute');
    }
  }
}
